var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcContractor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography",
    clipPath: "url(#clip0_2253_26413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8335 7.83334H3.3335V8.83334H6.8335V7.83334Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 5.33334H3.3335V6.33334H9.3335V5.33334Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 2.83334H3.3335V3.83334H9.3335V2.83334Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42683 14.3333H1.8335C1.28016 14.3333 0.833496 13.8867 0.833496 13.3333V1.33334C0.833496 0.78001 1.28016 0.333344 1.8335 0.333344H10.8335C11.3868 0.333344 11.8335 0.78001 11.8335 1.33334V4.39334H10.8335V1.33334H1.8335V13.3333H4.42683V14.3333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1002 7.21334L13.4535 5.56668C13.3068 5.42001 13.1002 5.33334 12.8935 5.33334C12.6868 5.33334 12.4802 5.41334 12.3335 5.56668L5.3335 12.5667V15.3333H8.10016L15.1002 8.33334C15.2468 8.18668 15.3335 7.98001 15.3335 7.77334C15.3335 7.56668 15.2535 7.36001 15.1002 7.21334ZM7.68683 14.3333H6.3335V12.98L11.0535 8.26001L12.4068 9.61334L7.68683 14.3333ZM13.1135 8.90668L11.7602 7.55334L12.8935 6.42001L14.2468 7.77334L13.1135 8.90668Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2253_26413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContractor);
export default __webpack_public_path__ + "static/media/ic-contractor.7b84ac8b39ee0d5dd0027baf33e97b0a.svg";
export { ForwardRef as ReactComponent };